import  { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {blogs} from "./blogs";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const foundBlog = blogs.find(b => b.id === Number(id));
    setBlog(foundBlog);
  }, [id]);
  if (!blog) {
    return (
      <div style={{ 
        padding: "40px", 
        backgroundColor: "white", 
        color: "black",
        textAlign: "center",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div>
          <h2>Blog Not Found</h2>
          <p>The blog post you're looking for doesn't exist.</p>
          <button 
            onClick={() => navigate("/blogs")}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#166534",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px"
            }}
          >
            Back to Blogs
          </button>
        </div>
      </div>
    );
  }

  const handlePageClick = () => {
    navigate(`/blog/${id}/ext`);
  };

  const handleBackClick = (e) => {
    e.stopPropagation();
    navigate("/blogs");
  };

  return (
    <div 
      onClick={handlePageClick}
      style={{
        padding: "40px 20px",
        backgroundColor: "white",
        color: "black",
        minHeight: "100vh",
        cursor: "pointer",
        transition: "background-color 0.3s ease"
      }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
    >
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* Back Button */}
        <button 
          onClick={handleBackClick}
          style={{
            padding: "10px 20px",
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            marginBottom: "30px",
            display: "inline-flex",
            alignItems: "center",
            gap: "5px"
          }}
        >
          ← Back to All Blogs
        </button>

        {/* Blog Header */}
        <div style={{ marginBottom: "30px" }}>
          <h1 style={{ 
            fontSize: "42px", 
            marginBottom: "15px", 
            color: "#333",
            borderBottom: "3px solid #166534",
            paddingBottom: "10px"
          }}>
            {blog.title}
          </h1>
          
          <div style={{ 
            display: "flex", 
            gap: "20px", 
            color: "#666",
            fontSize: "16px",
            marginBottom: "20px"
          }}>
            {blog.date && <span>Published: {blog.date}</span>}
           {/* {blog.author && <span> By: {blog.author}</span>}*/}
          </div>

          {blog.image && (
            <img 
              src={blog.image} 
              alt={blog.title}
              style={{
                width: "100%",
                maxHeight: "400px",
                objectFit: "cover",
                borderRadius: "10px",
                marginBottom: "30px"
              }}
            />
          )}
        </div>

        {/* Blog Content */}
        <div style={{ 
          fontSize: "18px", 
          lineHeight: "1.8", 
          color: "#333",
          marginBottom: "40px"
        }}>
          {blog.content ? (
            <div dangerouslySetInnerHTML={{ __html: blog.content }} />
          ) : (
            <p>{blog.excerpt}</p>
          )}
        </div>

        {/* EXT Content Call to Action */}
        <div style={{
          marginTop: "40px",
          padding: "30px",
          background: "linear-gradient(135deg, #166534 0%, #15803d 100%)",
          borderRadius: "10px",
          textAlign: "center",
          color: "white"
        }}>
          <h2 style={{ fontSize: "28px", marginBottom: "15px" }}>
            Add EXT Notes
          </h2>
          <p style={{ fontSize: "18px", marginBottom: "20px", opacity: "0.9" }}>
            Click anywhere on this page to add additional notes or comments about this blog post
          </p>
          <div style={{
            fontSize: "14px",
            opacity: "0.8",
            display: "flex",
            justifyContent: "center",
            gap: "20px"
          }}>
            <span>Write notes</span>
            <span> Save content</span>
            <span> View saved EXT</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;